export default "__VITE_ASSET__CJUL9GbG__"